import API from "api/axiosInstance";
import {
  setIsLoading,
  setListAbsensiBulanan,
  setListAbsensiHarian,
  setListAbsensiHariIni,
  setMessage,
  setStatus,
} from "./index";

export const fetchListAbsensiHariini = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/api/attendance/absenhariini");
    dispatch(setIsLoading(false));
    dispatch(setListAbsensiHariIni(response.data.list_absensi));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchListAbsensiHarian = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/api/attendance/absenharian");
    dispatch(setIsLoading(false));
    dispatch(setListAbsensiHarian(response.data.list_absensi_harian));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchListAbsensiBulanan = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/api/attendance/absenbulanan");
    dispatch(setIsLoading(false));
    dispatch(setListAbsensiBulanan(response.data.list_absensi_bulanan));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchEditAbsensi = (redData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post("/api/attendance/update_shift", redData);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setMessage(error.response.data.error ?? "Ada Kendala di Server"));
    dispatch(setStatus("failed"));
  }
};
